import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import { hybrid } from '@kd/hybrid';
import { inApp } from '@kd/env';
import api from './api.json';
const isProd = process.env.NODE_ENV === 'production';
const isMock = process.env.NODE_ENV === 'development' && !process.env.VUE_APP_PROXY_ENV;

interface RequestOptions {
  headers?: { [key: string]: unknown };
  method: string;
  url: string;
  params?: { [key: string]: unknown };
  data?: string | FormData;
}

interface ResponseOptions {
  errNo: string | number;
  errstr?: string;
  data: { [key: string]: unknown };
}

/**
 * axios 默认配置
 */
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    return Promise.reject(error.response);
  }
);

/**
 * 响应处理
 */
function responseHandler(response: ResponseOptions) {
  const { errNo } = response;
  console.log('errNo', errNo);
  if (typeof errNo !== 'undefined') {
    switch (Number(errNo)) {
      case 0:
        return response;
      case 3:
      case 13:
        console.log('未登录'); //  eslint-disable-line
        return Promise.reject(response); //  eslint-disable-line
      default:
        return Promise.reject(response); //  eslint-disable-line
    }
  }
}

/**
 *  NA 请求封装
 */
async function naRequest(
  type: string,
  url: string,
  params: { [index: string]: string | Blob },
  options?: {
    [index: string]: string | number | boolean | { [key: string]: unknown };
  }
) {
  !params && (params = {});
  try {
    let result = null;
    let host = Number(Vue.$cmn.vc) >= 213 && Vue.$cmn.appid === 'scancode' ? Vue.$cmn.host : location.origin;
    const proxyEnv = process.env.NODE_ENV === 'development' && process.env.VUE_APP_PROXY_ENV;
    if (proxyEnv) {
      host = '//' + proxyEnv;
    }
    console.log('🚀 ~ file: http.ts ~ line 77 ~ host', host);
    // const host = 'https://www.kuaiduizuoye.com';
    await new Promise(resolve => hybrid('core_httpRequest', { url: host + url, params, type, ...options }, resolve)) //  eslint-disable-line
      .then((res: any) => {
        // eslint-disable-line
        try {
          const { data, errorTips } = res;
          if (data && errorTips === '') {
            const response = {
              errNo: typeof data.errNo === 'undefined' ? 0 : data.errNo,
              data: data.data,
              errstr: data.errstr || ''
            };
            result = responseHandler(response);
          } else {
            result = Promise.reject(errorTips ? { errstr: errorTips } : new Error('请求失败'));
          }
        } catch (e) {
          console.log('未知错误', e); //  eslint-disable-line
          result = Promise.reject(new Error('请求失败'));
        }
      });
    console.log('line99~~~', result);
    return result;
  } catch (error) {
    console.log('未知错误'); //  eslint-disable-line
    return Promise.reject(new Error('请求失败'));
  }
}

/**
 * 响应处理
 */
function gtRequestHandle(base, params) {
  const host = location.origin.indexOf('kuaiduizuoye.com') > -1 ? '' : 'https://gtactivity-zhangli-e.suanshubang.cc';
  base.url = host + base.url;
  const commomParams = {
    cuid: Vue.$cmn.cuid || '',
    appId: 'scancode',
    withCredentials: true
  };
  Object.assign(params, commomParams);
}

/**
 *  FE Ajax 请求封装
 */
async function feRequest(
  type: string,
  url: string,
  params: { [index: string]: string | Blob },
  options?: {
    [index: string]: string | number | boolean | { [key: string]: unknown };
  }
) {
  const base: RequestOptions = {
    method: type,
    url: !isProd ? '/api' + url : url
  };
  if (url.indexOf('/gtactivity') === 0 && isProd) {
    params = params || {};
    gtRequestHandle(base, params);
  }
  type === 'get' && (base.params = params);
  type === 'post' && (base.data = qs.stringify(params));
  if (type === 'form') {
    const formData = new FormData();
    Object.keys(params).forEach(el => {
      formData.append(el, params[el]);
    });
    base.method = 'post';
    base.data = formData;
    base.headers = { 'content-type': 'multipart/form-data' };
  }
  try {
    const response = await axios({ ...base, ...options, withCredentials: true } as any);
    return responseHandler(response.data);
  } catch (error) {
    console.log('未知错误'); //  eslint-disable-line
    return Promise.reject(new Error('请求失败'));
  }
}
/**
 * http 封装（目前仅支持get/post/form）
 */
function http(
  type: string
): (
  url: string,
  params: { [index: string]: string | Blob },
  options?: {
    [index: string]: string | number | boolean | { [key: string]: unknown };
  }
) => void {
  return async function(
    url: string,
    params: { [index: string]: string | Blob },
    options?: {
      [index: string]: string | number | boolean | { [key: string]: unknown };
    }
  ) {
    const method = type === 'naCore' ? 'post' : type;
    if (type === 'naCore' && inApp && !isMock) {
      // 带 antispam 参数返回值不加密
      return naRequest(method, url, params, {
        paramsEncode: 1,
        shouldDecode: 0
      });
    } else {
      // FE 接口请求
      return feRequest(method, url, params, options);
    }
  };
}

/**
 *  端内加密 请求封装
 */
async function deRequest(url: string, params: { [index: string]: string | Blob }): Promise<void> {
  if (!inApp) {
    return feRequest('post', url, params) as any;
  }
  // 解决安卓无参数调decode_httpRequest报错问题
  if (!params || JSON.stringify(params) === '{}') {
    params = { notEmptyForAndrod: '1' };
  }
  try {
    let result: any = null; // eslint-disable-line
    await new Promise(resolve => hybrid('decode_httpRequest', { url, params, shouldDecode: 1 }, resolve)) //  eslint-disable-line
      .then((res: any) => {
        // eslint-disable-line
        try {
          if (res) {
            console.log(res);
            try {
              res.data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
            } catch (e) {
              console.log(e);
            }
            result = responseHandler(res);
          } else {
            result = Promise.reject(new Error('请求失败'));
          }
        } catch (e) {
          console.log('未知错误', e); //  eslint-disable-line
          result = Promise.reject(new Error('请求失败'));
        }
      });
    return result;
  } catch (error) {
    console.log('未知错误'); //  eslint-disable-line
    return Promise.reject(new Error('请求失败'));
  }
}

function deRequestV2(url: string, params: { [index: string]: string | Blob }): unknown {
  if (Number(Vue.$cmn.vc) >= 282) {
    return deRequest(url, params);
  } else {
    if (url && url.slice(-2) === 'v2') {
      url = url.substring(0, url.length - 2);
    }
    const naCore = http('naCore');
    return naCore(url, params);
  }
}

export const $ajax = axios;

export const $get = http('get');

export const $post = http('post');

export const $form = http('form');

export const $naCore = http('naCore');

export const $hybrid = hybrid;

export const $deHttp = deRequest;
export const $deHttpV2 = deRequestV2;

export default {
  install(Vue: Vue.VueConstructor): void {
    Vue.$ajax = Vue.prototype.$ajax = $ajax;
    Vue.api = Vue.prototype.api = api;
    Vue.$http = Vue.prototype.$http = {
      get: $get,
      post: $post,
      form: $form,
      naCore: $naCore,
      entry: $deHttp,
      entryV2: $deHttpV2
    };
  }
};
